import React from 'react';
import classNames from 'classnames';
import Button from '@alltrails/shared/denali/components/Button';

import { StringConstantsMixin, replaceStrings } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

import * as styles from './styles/styles.module.scss';

export type ShowMoreItemsProps = {
  title: string;
  config: {
    min: number;
    max: number;
    total: number;
    whiteBackground?: boolean;
  };
  handler: () => void;
};

const ShowMoreItems = ({ title, config, handler }: ShowMoreItemsProps): JSX.Element => {
  if (config.max >= config.total) {
    return null;
  }

  const showingStringsConfig = [
    { stringKey: 'min', stringValue: config.min },
    { stringKey: 'max', stringValue: config.max },
    { stringKey: 'total', stringValue: config.total }
  ];
  const showingStringsText = replaceStrings(StringConstantsMixin.strings.SEARCH.SHOWING_AMOUNT_OF_TOTAL, showingStringsConfig);
  return (
    <div className={classNames(styles.container, StringConstantsMixin.constants.XLATE.NONE)}>
      <Button text={title} onClick={handler} testId={title} variant={config.whiteBackground ? 'flat' : 'primary'} />
      <div className={styles.showing}>{showingStringsText}</div>
    </div>
  );
};

export default ShowMoreItems;
